export default __webpack_public_path__ + "static/media/hht1_ep01_timeline_02.0be400b9.png";